<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "AddressList" });
import * as API from "../../services/api.js";
import { ADDRESS_STORE, ADDRESS_HASH } from "../../services/store.js";
import { onDestroy, onMount } from "svelte";
import { get, writable, derived } from "svelte/store";
export let parameters;
const STORE = writable([]);
let unsubscribe;
let isLoading = false;
let previousParams = "";
let previousHash = $ADDRESS_HASH;
const syncFromGlobalStore = (data) => {
    const ADDRESSES = get(STORE).map((address) => {
        const KEY = address._.key;
        if (!(KEY in data)) {
            return address;
        }
        return data[KEY];
    });
    STORE.set(ADDRESSES);
};
const setStore = (addresses) => {
    STORE.set(addresses);
    isLoading = false;
};
const onParametersChange = (parameters2) => {
    const CURRENT_PARAMS = JSON.stringify(parameters2);
    if (CURRENT_PARAMS === previousParams) {
        return;
    }
    previousParams = CURRENT_PARAMS;
    isLoading = true;
    void API.filterAddresses({ ...parameters2 }).then(setStore);
};
$: onParametersChange(parameters);
const onAddressHashChange = (hash) => {
    if (hash === previousHash) {
        return;
    }
    previousHash = $ADDRESS_HASH;
    isLoading = true;
    void API.filterAddresses({ ...parameters }).then(setStore);
};
$: onAddressHashChange($ADDRESS_HASH);
onMount(() => {
    unsubscribe = ADDRESS_STORE.subscribe(syncFromGlobalStore);
});
onDestroy(() => {
    if (unsubscribe !== void 0) {
        unsubscribe();
    }
});
export const COUNT = derived(STORE, ($STORE) => $STORE.length);
</script>

{#if isLoading}
    <slot name = 'loading'/>
{:else if Array.isArray($STORE) && $STORE.length > 0}
    <slot addresses = { $STORE }>
        <pre>{ JSON.stringify($STORE, null, 4) }</pre>
    </slot>
{:else}
    <slot name = 'empty' />
{/if}